import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "fetch", "onChange", "sortable"],
    _excluded2 = ["control", "onUpdated"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useState } from 'react';
import { Controller } from 'react-hook-form';
import { SelectInput } from './SelectInput';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectAsyncInput = function SelectAsyncInput(_ref) {
  var value = _ref.value,
      fetch = _ref.fetch,
      onChange = _ref.onChange,
      _ref$sortable = _ref.sortable,
      sortable = _ref$sortable === void 0 ? true : _ref$sortable,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState([]),
      options = _useState[0],
      setOptions = _useState[1];

  var fetchOptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch();

          case 2:
            res = _context.sent;
            setOptions(res);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [fetch]);

  var handleChange = function handleChange(value) {
    if (!value || typeof value === 'string' || typeof value === 'number') {
      var opt = options.find(function (option) {
        return option.value === value;
      });
      onChange(opt);
    } else {
      onChange(value);
    }
  };

  return /*#__PURE__*/_jsx(SelectInput, _objectSpread({
    value: value,
    options: options,
    onChange: handleChange,
    onOpen: fetchOptions,
    sortable: sortable
  }, props));
};
export var SelectAsyncInputControlled = function SelectAsyncInputControlled(_ref3) {
  var control = _ref3.control,
      onUpdated = _ref3.onUpdated,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref4) {
      var _ref4$field = _ref4.field,
          value = _ref4$field.value,
          onChange = _ref4$field.onChange;

      var handleOnChange = function handleOnChange(e) {
        onChange(e);
        onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated(e);
      };

      return /*#__PURE__*/_jsx(SelectAsyncInput, _objectSpread(_objectSpread({}, props), {}, {
        value: value,
        onChange: handleOnChange
      }));
    }
  }));
};